import createIcon from '../../createIcon';

/**
 * @component @name Biotech
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxOS41QzUuOSAxOS41IDUgMjAuNCA1IDIxLjVIMTlDMTkgMjAuNCAxOC4xIDE5LjUgMTcgMTkuNUgxM1YxNy41SDE2QzE3LjEgMTcuNSAxOCAxNi42IDE4IDE1LjVIMTBDOC4zNCAxNS41IDcgMTQuMTYgNyAxMi41QzcgMTEuNDEgNy41OSAxMC40NiA4LjQ2IDkuOTRDOC4xNyA5LjUzIDggOS4wNCA4IDguNUM4IDguMjkgOC4wNCA4LjA4IDguMDkgNy44OEM2LjI4IDguNjMgNSAxMC40MiA1IDEyLjVDNSAxNS4yNiA3LjI0IDE3LjUgMTAgMTcuNVYxOS41SDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuNTYgNi4wMUMxMS45MSA2LjA0IDEzIDcuMTQgMTMgOC41QzEzIDkuMjUgMTIuNjcgOS45MSAxMi4xNSAxMC4zN0wxMi43NCAxMS45OUwxMy42OCAxMS42NUwxNC4wMiAxMi41OUwxNS45IDExLjkxTDE1LjU2IDEwLjk3TDE2LjUgMTAuNjNMMTMuNzYgMy4xTDEyLjgyIDMuNDRMMTIuNDggMi41TDEwLjYgMy4xOEwxMC45NCA0LjEyTDEwIDQuNDdMMTAuNTYgNi4wMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC41IDEwQzExLjMyODQgMTAgMTIgOS4zMjg0MyAxMiA4LjVDMTIgNy42NzE1NyAxMS4zMjg0IDcgMTAuNSA3QzkuNjcxNTcgNyA5IDcuNjcxNTcgOSA4LjVDOSA5LjMyODQzIDkuNjcxNTcgMTAgMTAuNSAxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Biotech = createIcon('Biotech', [
  [
    'path',
    {
      d: 'M7 19.5C5.9 19.5 5 20.4 5 21.5H19C19 20.4 18.1 19.5 17 19.5H13V17.5H16C17.1 17.5 18 16.6 18 15.5H10C8.34 15.5 7 14.16 7 12.5C7 11.41 7.59 10.46 8.46 9.94C8.17 9.53 8 9.04 8 8.5C8 8.29 8.04 8.08 8.09 7.88C6.28 8.63 5 10.42 5 12.5C5 15.26 7.24 17.5 10 17.5V19.5H7Z',
      key: 'egqbmv',
    },
  ],
  [
    'path',
    {
      d: 'M10.56 6.01C11.91 6.04 13 7.14 13 8.5C13 9.25 12.67 9.91 12.15 10.37L12.74 11.99L13.68 11.65L14.02 12.59L15.9 11.91L15.56 10.97L16.5 10.63L13.76 3.1L12.82 3.44L12.48 2.5L10.6 3.18L10.94 4.12L10 4.47L10.56 6.01Z',
      key: '16bh8i',
    },
  ],
  [
    'path',
    {
      d: 'M10.5 10C11.3284 10 12 9.32843 12 8.5C12 7.67157 11.3284 7 10.5 7C9.67157 7 9 7.67157 9 8.5C9 9.32843 9.67157 10 10.5 10Z',
      key: 'rbr0hw',
    },
  ],
]);

export default Biotech;
